import {Dimensions, Platform} from 'react-native';

/**
 * Platform and screen size helpers
 */
export const isWeb = Platform.OS === 'web';

/**
 * Returns the value based on the screen height percentage.
 * @param {number} percent - The percentage value relative to the screen height.
 * @returns {number} - The calculated value based on the screen height.
 */
export const hdp = (percent: number) => {
  const {height} = Dimensions.get('window');
  return (height * percent) / 100;
};

/**
 * Returns the value based on the screen width percentage.
 * @param {number} percent - The percentage value relative to the screen width.
 * @returns {number} - The calculated value based on the screen width.
 */
export const wdp = (percent: number) => {
  const {width} = Dimensions.get('window');
  return (width * percent) / 100;
};

/**
 * Returns the value based on the screen size.
 * @param {number} smValue - The value to be used for small screens.
 * @param {number} lgValue - The value to be used for large screens.
 * @param {number} xsmValue - The value to be used for very small screens.
 * @returns {number} - The calculated value based on the screen size.
 */
export const getByScreenSize = (
  smValue: any,
  lgValue: any,
  xsmValue: any = smValue,
): any => {
  const {width} = Dimensions.get('window');
  return width < 380 ? xsmValue : width < 480 ? smValue : lgValue;
};

export const getResponsiveSize = (
  small: number,
  large: number,
  medium?: number,
) => {
  const {width} = Dimensions.get('window');
  if (width >= 1024) return large;
  if (width >= 768 && medium !== undefined) return medium;
  return small;
};

/**
 * Returns the value based on the screen height.
 * @param {number} smValue - The value to be used for small screens.
 * @param {number} lgValue - The value to be used for large screens.
 * @returns {number} - The calculated value based on the screen height.
 */
export const getByScreenHeight = (smValue: number, lgValue: number) => {
  const {height} = Dimensions.get('window');
  return height < 900 ? smValue : lgValue;
};

/**
 * Derived screen size helpers
 */
export const isMobile = wdp(100) < 768;
export const isLargeScreen = wdp(100) >= 768;
